import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { OrderForListing } from '../../models/OrderForListing';

interface ILensMaterialPopoverProps {
  orderForListing: OrderForListing;
}

export const LensMaterialPopover: React.FC<ILensMaterialPopoverProps> = ({
  orderForListing
}) => {

  const iconColor = 'black';
  const number = orderForListing.lensMaterialList?.length || 0;

  if (number <= 1) return null;

  return (
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>
          {orderForListing.lensMaterialList?.map((material, nindex) => {
            return (
              <div key={`material-${orderForListing.order.id}-${nindex}`} style={{ textAlign: 'left' }}>{material}</div>
            );
          })}
        </Tooltip>}
      >
        <span><FontAwesomeIcon icon={faInfoCircle} color={iconColor} size='sm' /></span>
      </OverlayTrigger>
    </span>
  );

}